// extracted by mini-css-extract-plugin
export default {"ModalContainer":"Modal_ModalContainer__IXOpT"};